import injectIntl from "../../../../../common/helpers/injectIntl";

import MelodyTable from "./lazy";

export default injectIntl(MelodyTable);